import { Box, Icon, Text, Tooltip } from "@chakra-ui/react";
import { memo } from "react";
import { Link } from "react-router-dom";

type Props = {
  key: any;
  icon: any;
  icon2?: any;
  url: string;
  text: string;
  active?: boolean;
  onClick?: () => void;
  isCollapsed: boolean;
};

const ListItem = memo(
  ({ url, text, icon, icon2, active, onClick, isCollapsed }: Props) => (
    <Link to={url} onClick={onClick}>
      <Tooltip
        label={text}
        placement="right"
        size={"md"}
        isDisabled={!isCollapsed}
        hasArrow
        p="3"
        rounded={"md"}
        bg="gray.700"
        color="white"
      >
        <Box
          p={4}
          mx={2}
          gap={3}
          display="flex"
          cursor="pointer"
          borderRadius="lg"
          flexDirection="row"
          alignItems="center"
          transition="all 0.2s ease"
          color={active ? "#fff" : "gray.600"}
          background={active ? "primary.500" : "transparent"}
          _hover={{
            color: "#fff",
            bgColor: "primary.500",
            transform: "translateX(4px)",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          }}
        >
          <Icon
            width={5}
            height={5}
            as={active ? icon2 : icon}
            color={active ? "#fff" : "gray.500"}
            transition="all 0.2s ease"
          />
          {!isCollapsed ? (
            <Text
              lineHeight="20px"
              fontSize={15}
              fontWeight={active ? 600 : 500}
              transition="all 0.2s ease"
            >
              {text}
            </Text>
          ) : null}
        </Box>
      </Tooltip>
    </Link>
  )
);

ListItem.displayName = "ListItem";

export default ListItem;
